import MealsMenuUIModel from './mealsmenu';

class MealsMenuCollectionUIModel {
  constructor(obj) {
    this.items = [];
    if (obj !== null) {
      let item = null;
      const mealItems = [];
      obj.mealList.map(meal => {
        item = new MealsMenuUIModel(meal);
        mealItems.push(item);
      });
      this.items = mealItems;
    }
  }

  getItems() {
    return this.items;
  }
}

export default MealsMenuCollectionUIModel;
